// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #333333;
  /* Charcoal Gray */
  --secondary-color: #e9ecef;
  /* Soft Gray */
  --background-color: #ffffff;
  /* Pure White Background */
  --text-color: #444444;
  /* Medium Dark Gray */
  --accent-color: #6c757d;
  /* Muted Gray for accents */
  --card-bg: rgba(255, 255, 255, 0.98);
  /* Near-white for cards */
  --font-family: 'Roboto', 'Inter', sans-serif;
}

body {
  margin: 0;
  font-family: var(--font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--background-color);
  color: var(--text-color);
  min-height: 100vh;
}



code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}



@keyframes pulsate {
  from {
    transform: scale(1, 1);
    opacity: 1;
  }

  to {
    transform: scale(1.3, 1.3);
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,2BAA2B;EAC3B,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,oCAAoC;EACpC,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,mCAAmC;EACnC,kCAAkC;EAClC,yCAAyC;EACzC,wBAAwB;EACxB,iBAAiB;AACnB;;;;AAIA;EACE;aACW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;;;AAIA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF","sourcesContent":[":root {\n  --primary-color: #333333;\n  /* Charcoal Gray */\n  --secondary-color: #e9ecef;\n  /* Soft Gray */\n  --background-color: #ffffff;\n  /* Pure White Background */\n  --text-color: #444444;\n  /* Medium Dark Gray */\n  --accent-color: #6c757d;\n  /* Muted Gray for accents */\n  --card-bg: rgba(255, 255, 255, 0.98);\n  /* Near-white for cards */\n  --font-family: 'Roboto', 'Inter', sans-serif;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-family);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--background-color);\n  color: var(--text-color);\n  min-height: 100vh;\n}\n\n\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n\n\n@keyframes pulsate {\n  from {\n    transform: scale(1, 1);\n    opacity: 1;\n  }\n\n  to {\n    transform: scale(1.3, 1.3);\n    opacity: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
